(function() {
    'use strict';
    angular
        .module('MW.Influencers.ContactCard', [
            'MW.Framework.TranslationService',
            'ngMaterial',
            'mwAppComponents',
            'MW.Influecners.UnsubscribeBadge',
            'MW.Influencers.MiniProfileService'
        ])
        .directive('contactCard', function () {
            return {
                restrict: 'E',
                templateUrl: 'icm-web/views/partials/contact_card/contact_card',
                scope: {
                    contact: '=',
                    onClickBody: '&?',
                    showRelevantArticles: '&?',
                    relevantArticleCount: '@?',
                    showMediaList: '@?',
                    icmBaseUrl: '@?'
                },
                link: function(scope, element) {
                    // if we have a icmBaseUrl that means we are navigating between apps, need to set the target
                    if(scope.icmBaseUrl) {
                        element.find('.contactLink, .sourceLink').attr('target', '_self');
                    }
                },
                controller: ContactCardController,
                controllerAs: 'contactCardController'
            };
        })
        .controller('contactCardController', [
            '$scope',
            '$translate',
            'translationService',
            'MiniProfileService',
            ContactCardController
        ]);

    function ContactCardController($scope, $translate, translationService, MiniProfileService, IRM_BASE_URL) {
        this.$translate = $translate;
        var baseUrl = $scope.icmBaseUrl ? ($scope.icmBaseUrl + '/') : '';

        if($scope.contact.sourceType) {
            this.contactUrl = IRM_BASE_URL + '/source/' + $scope.contact.id;
        } else {
            this.contactUrl = IRM_BASE_URL + '/contact/' + $scope.contact.id;
        }

        if($scope.contact.automated) {
            this.contactUrl += '?automated=true';
        }

        $scope.$on('$locationChangeStart', function(){
            MiniProfileService.closeMiniProfile();
            MiniProfileService.closeMiniProfileBanner();
        });

        this.sourceBaseUrl = baseUrl + 'influencers/source/view';
        this.mediaListBaseUrl = baseUrl + 'influencers/contact-list';

        this.translationService = translationService;
        this.relevantArticle = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Article', {ArticleCount: $scope.relevantArticleCount});
        this.relevantArticles = this.translationService.getLocalizedString('[[ArticleCount]] Relevant Articles', {ArticleCount: $scope.relevantArticleCount});
        this.mediaListLabel = this.$translate.instant('icm-contactlist__contact-card--media-lists-label');
        this.showMediaList = $scope.showMediaList ? true : false;
        this.hasFacebook = this.hasTwitter = this.hasLinkedIn = false;
        this.facebookUrl = this.twitterUrl = this.linkedinUrl = '';
        $scope.contact.channels.filter(function(obj){
            if(obj.type.toLowerCase() === 'facebook') {
                this.hasFacebook = true;
                this.facebookUrl = obj.url;
            }
            else if(obj.type.toLowerCase() === 'twitter') {
                this.hasTwitter = true;
                this.twitterUrl = obj.url;
            }
            else if(obj.type.toLowerCase() === 'linkedin') {
                this.hasLinkedIn = true;
                this.linkedinUrl = obj.url;
            }
            else if(obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'facebook') {
                this.hasFacebook = true;
                this.facebookUrl = obj.socialProfile.url;
            }
            else if(obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'twitter') {
                this.hasTwitter = true;
                this.twitterUrl = obj.socialProfile.url;
            }
            else if(obj.socialProfile && obj.socialProfile.type.toLowerCase() === 'linked_in') {
                this.hasLinkedIn = true;
                this.linkedinUrl = obj.socialProfile.url;
            }
        }.bind(this));
        this.hasSocial = this.hasFacebook || this.hasTwitter || this.hasLinkedIn;

        // Can be removed after old search pages is removed
        this.getCountry = function getCountry(contactInfo) {
            var address;
            if (contactInfo && contactInfo.address) {
                address = contactInfo.address[0];
                if (address && address.country) {
                    return address.country;
                }
            }
            return null;
        };
        this.country = $scope.contact.contactInfo.address[0].countryName ? $scope.contact.contactInfo.address[0].countryName : this.getCountry($scope.contact.contactInfo);
    }
}());
